interface FullscreenElement extends HTMLElement {
  webkitRequestFullscreen?: () => Promise<void> | void;
}

interface FullscreenDocument extends Document {
  webkitFullscreenElement?: Element | null;
}

export function playerIsFullscreen(): boolean {
  const fullscreenDocument = document as FullscreenDocument;
  return Boolean(document.fullscreenElement ?? fullscreenDocument.webkitFullscreenElement);
}

export async function requestPlayerFullscreen(): Promise<boolean> {
  if (playerIsFullscreen()) return true;
  const element = document.documentElement as FullscreenElement;
  try {
    if (element.requestFullscreen) {
      await element.requestFullscreen({ navigationUI: "hide" });
      return true;
    }
    if (element.webkitRequestFullscreen) {
      await element.webkitRequestFullscreen();
      return true;
    }
  } catch {
    // Standard browsers reject script-only fullscreen. The next player gesture retries it.
  }
  return playerIsFullscreen();
}
